import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { EmbeddedVideo, KeepProportions, PageHeader, PageSection, StartInkindCard, Wide } from '@gik/ui';
import MarketingNavSection from '../../components/MarketingNav/MarketingNavSection';
import StartInkindContent from '@gik/ui/gik/StartInkindCard/StartInkindContent';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { FeatureStepsSection } from '@gik/marketing/components/FeatureSteps';
import { SituationsOverviewSection } from '@gik/marketing/components/SituationsOverview';
import HowItWorksSamplePagesSection from './HowItWorksSamplePagesSection';
import TestimonialsCarouselSection from '@gik/ui/gik/TestimonialsCarouselSection';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';
import { useGikSettings } from '@gik/api/acf/gik-settings/gikSettings';

export interface HowItWorksPageProps {}

export default function HowItWorksPage(_props: HowItWorksPageProps): React.ReactElement {
  const bem = bemBlock('how-it-works-page');
  const { t } = useTranslation();
  const { data: gikSettings } = useGikSettings();

  return (
    <article className={bem()}>
      <PageHeader variant="aqua" decoration="foliage">
        <h1>{t(translationKeys.title)}</h1>
      </PageHeader>

      <PageSection className={bem('video')}>
        <KeepProportions proportion={Wide}>
          {gikSettings && (
            <EmbeddedVideo
              url={`https://www.youtube.com/watch?v=${gikSettings.acf.how_it_works_video_id}`}
              autoPlay={false}
            />
          )}
        </KeepProportions>
      </PageSection>

      <PageSection noPad>
        <StartInkindContent trackingId={CreateClickedLocation.HOW_IT_WORKS_TOP} />
      </PageSection>

      <FeatureStepsSection />
      <br className="xl" />
      <SituationsOverviewSection />
      <StartInkindCard trackingId={CreateClickedLocation.HOW_IT_WORKS_HALF} />
      <HowItWorksSamplePagesSection />
      <TestimonialsCarouselSection />
      <PageSection className={bem('start-inkind')}>
        <StartInkindContent trackingId={CreateClickedLocation.HOW_IT_WORKS_BOTTOM} />
      </PageSection>
      <MarketingNavSection variant="aqua" />
    </article>
  );
}
